export const DESKTOP_NAV_BAR_HEIGHT_PX = '80px';
export const MOBILE_NAV_BAR_HEIGHT_PX = '80px';
